export const toggle = <T,>(array: T[] | undefined, value: T): T[] | undefined => {
    if (array === undefined) {
        return [value];
    }
    const idx = array.indexOf(value);
    if (idx > -1) {
        if (array.length === 1) {
            return undefined;
        }
        return [...array.slice(0, idx), ...array.slice(idx + 1)];
    }
    return [...array, value];
};
